import React, { useState } from 'react'
import { Trans } from 'react-i18next'
import InView from 'react-intersection-observer'
import { animated, useSpring } from 'react-spring'

import logo from '../../2021/images/logo.svg'

import * as styles from './styles.module.scss'

const Footer: React.FC = () => {
	const [startAnimation, setStartAnimation] = useState(false)

	const style = useSpring({
		transform: `translateX(${startAnimation ? 0 : `200px`})`,
		opacity: startAnimation ? 1 : 0,
		config: { mass: 1, tension: 400, friction: 80 },
		delay: 1000
	})

	return (
		<footer className={styles.footer}>
			<div className="container text-start h-100 d-flex flex-column justify-content-end pb-md-8 pb-6">
				<animated.div className="h1 font-weight-bold mb-6 px-2" style={style}>
					<Trans
						i18nKey="footer.text"
						components={[<a href="https://notino.jobs.cz/" target="_blank" />]}
					/>
				</animated.div>
				<InView onChange={(inView) => inView && setStartAnimation(true)} />
				<img src={logo} alt="NOTINO" className={styles.logo} />
			</div>
		</footer>
	)
}

export default Footer
